export const IMAGES = {
  heroTeacher:
    "https://images.unsplash.com/photo-1522661067900-ab829854a57f?crop=entropy&cs=srgb&fm=jpg&q=85",
  classroomKids:
    "https://images.unsplash.com/photo-1692269725836-fbd72e98883f?crop=entropy&cs=srgb&fm=jpg&q=85",
  boyBook:
    "https://images.unsplash.com/photo-1623303366639-0e330d7c3d9f?crop=entropy&cs=srgb&fm=jpg&q=85",
  onlineClass:
    "https://images.unsplash.com/photo-1619852182277-79aa23f82c8e?crop=entropy&cs=srgb&fm=jpg&q=85",
  illAbout:
    "https://static.prod-images.emergentagent.com/jobs/7a3767f5-e547-43b0-9148-13b279fbffb3/images/c563b080f9b8a2ec3e4c922124521977b60fa3ef06bff97aeb383befd2efb6da.jpeg",
  illOnline:
    "https://static.prod-images.emergentagent.com/jobs/7a3767f5-e547-43b0-9148-13b279fbffb3/images/b71b8b869abf2e90ed430a146c2ffba53c9bf8c254558f00705e73cb606d916c.jpeg",
  illAkshar:
    "https://static.prod-images.emergentagent.com/jobs/7a3767f5-e547-43b0-9148-13b279fbffb3/images/1563752bf6ec5336398923a2ba816046b0e212384b18258b84922d541d269f3a.jpeg",
};

export const WHATSAPP_NUMBER = "919908310130";
export const WHATSAPP_DISPLAY = "+91 99083 10130";

const en = {
  meta: {
    home: {
      title: "K V Nagalakshmi — Online Hindi Classes for Primary & High School | Hyderabad",
      desc: "Online Hindi lessons for primary and high school students by K V Nagalakshmi, Hyderabad — 25+ years of teaching, Hindi Pandit, former Primary Head of Department. Enquire on WhatsApp.",
    },
    about: {
      title: "About K V Nagalakshmi — Hindi Teacher with 25+ Years' Experience",
      desc: "25+ years teaching Hindi, Hindi Pandit qualification, curriculum planning and Primary Head of Department experience — meet your Hyderabad-based online Hindi teacher.",
    },
    classes: {
      title: "Online Hindi Classes — Primary & High School | K V Nagalakshmi",
      desc: "Live online Hindi classes: primary basics, high school grammar and exam preparation, and gentle support for students transitioning into Hindi.",
    },
    faqs: {
      title: "FAQs — Online Hindi Classes | K V Nagalakshmi",
      desc: "Answers for parents: who the classes are for, how online lessons work, indicative timings, fees and getting started.",
    },
    contact: {
      title: "Enquire — Online Hindi Classes | K V Nagalakshmi, Hyderabad",
      desc: "Fill a short form and we prepare a WhatsApp message to K V Nagalakshmi for you to review and send. Plain-language privacy notice.",
    },
  },
  nav: {
    home: "Home",
    about: "About",
    classes: "Online Classes",
    faqs: "FAQs",
    contact: "Contact",
    cta: "Enquire now",
    openMenu: "Open menu",
    closeMenu: "Close menu",
    langLabel: "हिंदी में पढ़ें",
    langShort: "हिंदी",
  },
  brand: { name: "K V Nagalakshmi", role: "Hindi Teacher · Hyderabad" },
  hero: {
    eyebrow: "Online Hindi classes · Primary to high school",
    line1: "Hindi, learned",
    line2: "with confidence.",
    sub: "Warm, well-planned online lessons by K V Nagalakshmi — 25+ years in the classroom, a qualified Hindi Pandit, and a former Primary Head of Department.",
    ctaPrimary: "Enquire on WhatsApp",
    ctaSecondary: "Meet the teacher",
    badges: ["25+ years teaching", "Hindi Pandit", "Based in Hyderabad"],
    photoAlt: "A teacher writing on a classroom blackboard",
    floatingNote: "Patience first — every child learns at their own pace.",
  },
  marquee: [
    "25+ Years of Teaching",
    "हिंदी पंडित",
    "Curriculum Planning",
    "प्राथमिक विभागाध्यक्ष",
    "Engaging Activities",
    "New-to-Hindi Support",
    "हिंदी सीखिए, प्रेम से",
  ],
  bento: {
    eyebrow: "Why parents trust her",
    title: "A classroom built on",
    titleAccent: "experience",
    sub: "Every lesson draws on decades of real classroom work — not just knowing Hindi, but knowing how children learn it.",
    cards: [
      {
        stat: "25+",
        label: "Years of teaching",
        text: "More than two decades of teaching Hindi to primary and high school students.",
      },
      {
        label: "Hindi Pandit",
        text: "Formally qualified in Hindi language and literature.",
      },
      {
        label: "Primary HOD",
        text: "Head of Department for Primary — leading how young children are taught.",
      },
      {
        label: "Curriculum planning",
        text: "Lessons planned stage by stage, so learning never feels sudden.",
      },
      {
        label: "Engaging activities",
        text: "Stories, games and activities that make Hindi a class to look forward to.",
      },
      {
        label: "New to Hindi?",
        text: "Gentle, structured support for students transitioning into the language.",
      },
    ],
  },
  programs: {
    eyebrow: "Who the classes are for",
    title: "From first akshara to board exams",
    sub: "One teacher, one plan — matched to your child's class and pace.",
    cards: [
      {
        tag: "Primary · Classes 1–5",
        title: "Strong beginnings",
        items: ["Varnamala, matras & pronunciation", "Reading aloud & listening", "Everyday vocabulary", "Stories, rhymes & activities"],
      },
      {
        tag: "High school · Classes 6–10",
        title: "School-ready Hindi",
        items: ["Grammar, step by step", "Comprehension & reading practice", "Essays, letters & writing skills", "Exam preparation & revision"],
      },
      {
        tag: "Transitioning into Hindi",
        title: "A gentle bridge",
        items: ["Start from the akshara, if needed", "Everyday phrases first", "Extra practice at a kind pace", "Support through school changes"],
      },
    ],
    imageAlt: "Children learning together in a classroom",
  },
  steps: {
    eyebrow: "How enquiring works",
    title: "An enquiry takes one minute",
    sub: "No accounts, no waiting — the form prepares a WhatsApp message, and you stay in control of what is sent.",
    items: [
      {
        title: "Fill the short form",
        text: "Parent name, WhatsApp number, your child's class and what they need help with.",
      },
      {
        title: "Review your message",
        text: "We prepare a WhatsApp message for you. Read it, and edit it in WhatsApp if you wish.",
      },
      {
        title: "Send it on WhatsApp",
        text: "One tap opens WhatsApp with your message ready. You press send — nothing goes without you.",
      },
    ],
    cta: "Start your enquiry",
  },
  faqTeaser: {
    eyebrow: "Before you ask",
    title: "Questions parents often ask",
    cta: "Read all FAQs",
  },
  ctaBand: {
    title: "Not sure where your child should start?",
    text: "Send one WhatsApp message — tell me your child's class and what they need, and we will take it from there.",
    button: "Enquire now",
  },
  about: {
    eyebrow: "About",
    title: "Meet K V Nagalakshmi",
    intro:
      "I am a Hindi teacher based in Hyderabad. For more than 25 years I have taught Hindi to primary and high school students. Along the way, I have served as Primary Head of Department, planned curriculum for young learners, and helped many children — including those who began with no Hindi at all — find their feet in the language.",
    cvTitle: "Experience & qualifications",
    cv: [
      { t: "25+ years teaching Hindi", d: "Primary and high school students, in the classroom and online." },
      { t: "Hindi Pandit qualification", d: "Formal qualification in Hindi language and literature." },
      { t: "Curriculum planning", d: "Structured, stage-by-stage planning of what is taught and when." },
      { t: "Primary Head of Department", d: "Led primary teaching — how lessons are designed for young minds." },
      { t: "Engaging classroom activities", d: "Stories, games and activities that keep children involved." },
      { t: "Transition support", d: "Special care for students moving into Hindi from another medium." },
    ],
    philTitle: "How I teach",
    phil:
      "Hindi should not feel like a burden added to a child's day. Grammar is learned step by step, reading is practised aloud, and stories and activities keep children engaged. For students transitioning into Hindi — perhaps after a school change — I plan a gentler bridge, so they never feel left behind.",
    imageAlt: "An illustrated scene of a teacher reading stories to children",
    photoAlt: "A child holding a book, smiling",
  },
  classes: {
    eyebrow: "Online Classes",
    title: "Live lessons, planned around your child",
    sub: "From home, on a phone, tablet or computer — with a plan for every stage.",
    programsTitle: "What the classes cover",
    howTitle: "How the online classes work",
    howText:
      "Your child joins a live online session from home — a phone, tablet or computer with internet is enough. Lessons follow a plan; reading practice and homework keep the week steady. Batch details and the session platform are shared personally when you enquire.",
    imageAlt: "A student attending an online class on a laptop",
    timingsEyebrow: "Planning ahead",
    timingsTitle: "Indicative batch timings",
    timingsNote:
      "These evening slots are indicative, to help you plan. Please confirm the current schedule and availability on WhatsApp before fixing your child's batch.",
    slots: [
      { name: "Batch A", time: "4:30 – 5:30 PM · Mon–Thu" },
      { name: "Batch B", time: "5:45 – 6:45 PM · Mon–Thu" },
      { name: "Batch C", time: "7:00 – 8:00 PM · Mon–Thu" },
      { name: "Weekend sessions", time: "By appointment" },
    ],
    transTitle: "Joining Hindi for the first time?",
    transText:
      "Children who are new to Hindi get a gentle, structured bridge — starting from the varnamala if needed, with extra practice at a kind pace, so school feels less frightening and the language starts to feel like their own.",
    transCta: "Ask about transition support",
  },
  faqs: {
    eyebrow: "FAQs",
    title: "Common questions, straight answers",
    sub: "If your question is not here, message me on WhatsApp — I reply personally.",
    items: [
      {
        q: "Who are these classes for?",
        a: "Primary and high school students. Classes are conducted online, so your child can join from anywhere; I am based in Hyderabad.",
      },
      {
        q: "My child has never studied Hindi. Can they still join?",
        a: "Yes. A meaningful part of my work is helping students transitioning into Hindi — we start from the varnamala if needed and move at a pace your child is comfortable with.",
      },
      {
        q: "How are the classes conducted?",
        a: "As live online sessions. Your child needs a phone, tablet or computer with internet. Batch details and the session platform are shared when you enquire.",
      },
      {
        q: "What are the class timings?",
        a: "Evening batches on weekdays, and weekend sessions by appointment. See the indicative timings on the Online Classes page, then confirm availability on WhatsApp.",
      },
      {
        q: "What are the fees?",
        a: "Fees depend on your child's class and learning need, so they are shared personally after a short conversation. Message me on WhatsApp and I will explain everything clearly.",
      },
      {
        q: "Will my details stay private?",
        a: "Yes. Your form details are used only to reply to your enquiry and are never shared or sold. The privacy note on the Contact page explains this in plain words.",
      },
      {
        q: "How do we begin?",
        a: "Fill the short enquiry form — it prepares a WhatsApp message for you to review and send. We then fix a convenient time to talk.",
      },
    ],
    stillTitle: "Still have a question?",
    stillText: "Message me on WhatsApp — describe your child's class and need, and I will reply personally.",
    stillCta: "Message on WhatsApp",
  },
  contact: {
    eyebrow: "Contact",
    title: "Let's talk about your child's Hindi",
    sub: "Fill the short form below. We prepare a WhatsApp message for you to review — you send it from your own WhatsApp.",
    formTitle: "Enquiry form",
    labels: {
      name: "Parent's name",
      namePh: "e.g. Lakshmi Rao",
      phone: "WhatsApp number",
      phoneHint: "10-digit Indian mobile number",
      cls: "Student's class",
      need: "What does your child need help with?",
      needPh: "Choose one",
    },
    classOptions: [
      "Class 1", "Class 2", "Class 3", "Class 4", "Class 5",
      "Class 6", "Class 7", "Class 8", "Class 9", "Class 10",
      "New to Hindi (not started yet)",
    ],
    needOptions: [
      "School & exam support",
      "Grammar & reading",
      "Transitioning into Hindi",
      "Homework support",
      "Something else",
    ],
    submit: "Prepare my WhatsApp message",
    submitting: "Preparing…",
    errors: {
      name: "Please enter the parent's name.",
      phone: "Please enter a valid 10-digit WhatsApp number.",
      cls: "Please choose your child's class.",
      need: "Please tell us what help is needed.",
    },
    review: {
      title: "Your message is ready — please review it",
      explain:
        "Pressing “Open WhatsApp” opens WhatsApp with this message pre-filled, addressed to K V Nagalakshmi (+91 99083 10130). You can edit the message there before sending — nothing is sent until you press Send in WhatsApp.",
      open: "Open WhatsApp & review",
      edit: "Edit my details",
      done: "Sent? Thank you!",
      doneText:
        "If WhatsApp did not open, tap the number below to reach me directly. I usually reply personally on WhatsApp.",
    },
    privacy: {
      title: "Privacy, in plain words",
      items: [
        "What we collect: only what the form asks — parent name, WhatsApp number, your child's class and learning need.",
        "How it is used: to reply to your enquiry and arrange classes. Nothing else.",
        "Never shared or sold. No marketing messages.",
        "Want your details deleted? Message on WhatsApp and it is done.",
      ],
    },
    aside: {
      howTitle: "What happens next",
      howItems: [
        "You fill four short fields — nothing more.",
        "We prepare a WhatsApp message and show it to you first.",
        "You send it from your own WhatsApp, when you are ready.",
      ],
      directTitle: "Prefer to type it yourself?",
      directText: "Message K V Nagalakshmi directly on WhatsApp.",
      location: "Based in Hyderabad · Teaching online",
    },
    msg: {
      greet: "Namaste 🙏",
      intro: "I would like to enquire about online Hindi classes for my child:",
      parent: "Parent",
      cls: "Student's class",
      need: "Learning need",
      close: "Please share suitable timings and details.",
      footer: "(Sent from the website)",
    },
  },
  footer: {
    tagline: "Hindi, taught with warmth — online, for primary and high school students.",
    linksTitle: "Pages",
    contactTitle: "Contact",
    whatsapp: "WhatsApp",
    location: "Hyderabad · Online classes",
    privacyLine: "Enquiry details are used only to reply to you — never shared or sold.",
    rights: "All rights reserved.",
  },
};

const hi = {
  meta: {
    home: {
      title: "के वी नागलक्ष्मी — प्राथमिक एवं हाई स्कूल के लिए ऑनलाइन हिंदी कक्षाएँ | हैदराबाद",
      desc: "के वी नागलक्ष्मी द्वारा प्राथमिक और हाई स्कूल के विद्यार्थियों के लिए ऑनलाइन हिंदी पाठ — 25+ वर्षों का शिक्षण अनुभव, हिंदी पंडित, प्राथमिक विभागाध्यक्ष। व्हाट्सऐप पर पूछें।",
    },
    about: {
      title: "परिचय — के वी नागलक्ष्मी, 25+ वर्षों की हिंदी अध्यापिका",
      desc: "25+ वर्षों का हिंदी अध्यापन, हिंदी पंडित योग्यता, पाठ्यचर्या नियोजन एवं प्राथमिक विभागाध्यक्ष का अनुभव — मिलिए हैदराबाद की ऑनलाइन हिंदी अध्यापिका से।",
    },
    classes: {
      title: "ऑनलाइन हिंदी कक्षाएँ — प्राथमिक एवं हाई स्कूल | के वी नागलक्ष्मी",
      desc: "लाइव ऑनलाइन हिंदी कक्षाएँ: प्राथमिक की नींव, हाई स्कूल का व्याकरण और परीक्षा की तैयारी, तथा हिंदी में नए विद्यार्थियों के लिए सहज सहारा।",
    },
    faqs: {
      title: "सामान्य प्रश्न — ऑनलाइन हिंदी कक्षाएँ | के वी नागलक्ष्मी",
      desc: "अभिभावकों के प्रश्नों के उत्तर: कक्षाएँ किनके लिए हैं, ऑनलाइन पाठ कैसे चलते हैं, समय, शुल्क और शुरुआत।",
    },
    contact: {
      title: "संपर्क करें — ऑनलाइन हिंदी कक्षाएँ | के वी नागलक्ष्मी, हैदराबाद",
      desc: "छोटा फ़ॉर्म भरें; आपके लिए के वी नागलक्ष्मी को व्हाट्सऐप संदेश तैयार होगा — पहले देखें, फिर भेजें। सरल शब्दों में गोपनीयता नीति।",
    },
  },
  nav: {
    home: "होम",
    about: "परिचय",
    classes: "ऑनलाइन कक्षाएँ",
    faqs: "सामान्य प्रश्न",
    contact: "संपर्क",
    cta: "अभी पूछें",
    openMenu: "मेन्यू खोलें",
    closeMenu: "मेन्यू बंद करें",
    langLabel: "Read in English",
    langShort: "English",
  },
  brand: { name: "के वी नागलक्ष्मी", role: "हिंदी अध्यापिका · हैदराबाद" },
  hero: {
    eyebrow: "ऑनलाइन हिंदी कक्षाएँ · प्राथमिक से हाई स्कूल तक",
    line1: "हिंदी सीखिए",
    line2: "आत्मविश्वास के साथ।",
    sub: "के वी नागलक्ष्मी की सुव्यवस्थित और आत्मीय ऑनलाइन कक्षाएँ — 25+ वर्षों का शिक्षण अनुभव, हिंदी पंडित एवं प्राथमिक विभागाध्यक्ष (HOD)।",
    ctaPrimary: "व्हाट्सऐप पर पूछें",
    ctaSecondary: "शिक्षिका से मिलिए",
    badges: ["25+ वर्षों का अनुभव", "हिंदी पंडित", "हैदराबाद"],
    photoAlt: "कक्षा में ब्लैकबोर्ड पर लिखती हुई शिक्षिका",
    floatingNote: "पहले धैर्य — हर बच्चा अपनी गति से सीखता है।",
  },
  marquee: [
    "25+ वर्षों का शिक्षण",
    "हिंदी पंडित",
    "पाठ्यचर्या नियोजन",
    "प्राथमिक विभागाध्यक्ष",
    "रोचक गतिविधियाँ",
    "हिंदी में नए विद्यार्थियों का सहारा",
    "हिंदी सीखिए, प्रेम से",
  ],
  bento: {
    eyebrow: "अभिभावकों का भरोसा",
    title: "अनुभव से बनी",
    titleAccent: "कक्षा",
    sub: "हर पाठ दशकों के सही कक्षा-अनुभव पर आधारित है — सिर्फ़ हिंदी जानना नहीं, बच्चों को हिंदी सिखाने की समझ।",
    cards: [
      {
        stat: "25+",
        label: "वर्षों का शिक्षण",
        text: "पच्चीस वर्षों से अधिक समय से प्राथमिक और हाई स्कूल के विद्यार्थियों को हिंदी पढ़ाने का अनुभव।",
      },
      {
        label: "हिंदी पंडित",
        text: "हिंदी भाषा एवं साहित्य में औपचारिक योग्यता।",
      },
      {
        label: "प्राथमिक विभागाध्यक्ष",
        text: "प्राथमिक स्तर पर शिक्षण का नेतृत्व — छोटे बच्चों को पढ़ाने की दिशा।",
      },
      {
        label: "पाठ्यचर्या नियोजन",
        text: "पाठ चरण-दर-चरण योजना से — सीखना कभी भारी न लगे।",
      },
      {
        label: "रोचक गतिविधियाँ",
        text: "कहानियाँ, खेल और गतिविधियाँ — जिनसे हिंदी प्रिय विषय बन जाए।",
      },
      {
        label: "हिंदी नई है?",
        text: "हिंदी में नए विद्यार्थियों के लिए सहज और सुव्यवस्थित सहारा।",
      },
    ],
  },
  programs: {
    eyebrow: "कक्षाएँ किनके लिए हैं",
    title: "पहली अक्षर से बोर्ड परीक्षा तक",
    sub: "एक शिक्षिका, एक योजना — आपके बच्चे की कक्षा और गति के अनुसार।",
    cards: [
      {
        tag: "प्राथमिक · कक्षा 1–5",
        title: "मज़बूत शुरुआत",
        items: ["वर्णमाला, मात्राएँ और उच्चारण", "पढ़ने व सुनने का अभ्यास", "रोज़मर्रा की शब्दावली", "कहानियाँ, गीत और गतिविधियाँ"],
      },
      {
        tag: "हाई स्कूल · कक्षा 6–10",
        title: "स्कूल के अनुरूप हिंदी",
        items: ["व्याकरण, चरण-दर-चरण", "बोध और पठन-अभ्यास", "निबंध, पत्र और लेखन-कौशल", "परीक्षा की तैयारी और पुनरावृत्ति"],
      },
      {
        tag: "हिंदी में नए विद्यार्थी",
        title: "सहज रास्ता",
        items: ["ज़रूरत हो तो वर्णमाला से शुरुआत", "पहले रोज़मर्रा के वाक्य", "धीरे-धीरे अतिरिक्त अभ्यास", "स्कूल बदलने पर भी सहारा"],
      },
    ],
    imageAlt: "कक्षा में साथ सीखते बच्चे",
  },
  steps: {
    eyebrow: "पूछताछ कैसे होती है",
    title: "पूछताछ में बस एक मिनट",
    sub: "न अकाउंट, न इंतज़ार — फ़ॉर्म आपके लिए व्हाट्सऐप संदेश तैयार करता है, और नियंत्रण आपके हाथ में रहता है।",
    items: [
      {
        title: "छोटा फ़ॉर्म भरें",
        text: "अभिभावक का नाम, व्हाट्सऐप नंबर, बच्चे की कक्षा और ज़रूरत।",
      },
      {
        title: "संदेश देख लें",
        text: "आपके लिए व्हाट्सऐप संदेश तैयार होता है। पढ़ लें — चाहें तो व्हाट्सऐप में बदल भी सकते हैं।",
      },
      {
        title: "व्हाट्सऐप से भेजें",
        text: "एक टैप में व्हाट्सऐप खुलेगा, संदेश तैयार। भेजना आपके हाथ में है।",
      },
    ],
    cta: "पूछताछ शुरू करें",
  },
  faqTeaser: {
    eyebrow: "जानने से पहले",
    title: "अभिभावकों के सामान्य प्रश्न",
    cta: "सभी प्रश्न देखें",
  },
  ctaBand: {
    title: "समझ नहीं आ रहा, शुरुआत कहाँ से हो?",
    text: "एक व्हाट्सऐप संदेश भेजिए — बच्चे की कक्षा और ज़रूरत बताइए, फिर हम आगे की योजना बनाएंगे।",
    button: "अभी पूछें",
  },
  about: {
    eyebrow: "परिचय",
    title: "मिलिए के वी नागलक्ष्मी से",
    intro:
      "मैं हैदराबाद की हिंदी अध्यापिका हूँ। पिछले 25+ वर्षों से मैं प्राथमिक और हाई स्कूल के विद्यार्थियों को हिंदी पढ़ा रही हूँ। इस दौरान मैंने प्राथमिक विभागाध्यक्ष (HOD) के रूप में कार्य किया, छोटे बच्चों के लिए पाठ्यचर्या की योजना बनाई, और उन बच्चों को भी हिंदी से जोड़ा जो बिल्कुल शुरुआत से हिंदी सीखते थे।",
    cvTitle: "अनुभव एवं योग्यता",
    cv: [
      { t: "हिंदी अध्यापन — 25+ वर्ष", d: "प्राथमिक और हाई स्कूल के विद्यार्थियों को, कक्षा में और ऑनलाइन।" },
      { t: "हिंदी पंडित योग्यता", d: "हिंदी भाषा एवं साहित्य में औपचारिक योग्यता।" },
      { t: "पाठ्यचर्या नियोजन", d: "क्या और कब पढ़ाया जाए — इसकी चरणबद्ध योजना।" },
      { t: "प्राथमिक विभागाध्यक्ष", d: "प्राथमिक शिक्षण का नेतृत्व — छोटे बच्चों के पाठों की बनावट।" },
      { t: "रोचक कक्षा-गतिविधियाँ", d: "कहानियाँ, खेल और गतिविधियाँ जो बच्चों को जोड़े रखती हैं।" },
      { t: "नए विद्यार्थियों का सहारा", d: "दूसरे माध्यम से हिंदी में आ रहे बच्चों की विशेष देखभाल।" },
    ],
    philTitle: "मैं कैसे पढ़ाती हूँ",
    phil:
      "हिंदी बच्चे के दिन का बोझ नहीं होनी चाहिए। व्याकरण चरण-दर-चरण सीखा जाता है, पढ़ने का अभ्यास ऊँची आवाज़ में होता है, और कहानियाँ-गतिविधियाँ बच्चों को जोड़े रखती हैं। हिंदी में नए विद्यार्थियों — शायद स्कूल बदलने के बाद — के लिए सहज रास्ता रखा जाता है, ताकि वे पीछे छूटा महसूस न करें।",
    imageAlt: "बच्चों को कहानी सुनाती शिक्षिका का चित्रण",
    photoAlt: "किताब पकड़े हुए मुस्कुराता बच्चा",
  },
  classes: {
    eyebrow: "ऑनलाइन कक्षाएँ",
    title: "लाइव पाठ, आपके बच्चे के अनुसार",
    sub: "घर से, फ़ोन, टैबलेट या कंप्यूटर पर — हर स्तर के लिए एक योजना।",
    programsTitle: "कक्षाओं में क्या सिखाया जाता है",
    howTitle: "ऑनलाइन कक्षाएँ कैसे चलती हैं",
    howText:
      "बच्चा घर से सीधे लाइव ऑनलाइन कक्षा में शामिल होता है — इंटरनेट वाला फ़ोन, टैबलेट या कंप्यूटर पर्याप्त है। पाठ एक योजना से चलते हैं; पठन-अभ्यास और गृहकार्य से हफ़्ता नियमित रहता है। बैच की जानकारी और प्लेटफ़ॉर्म पूछताछ पर व्यक्तिगत रूप से साझा किया जाता है।",
    imageAlt: "लैपटॉप पर ऑनलाइन कक्षा में शामिल होता विद्यार्थी",
    timingsEyebrow: "आगे की सोच-विचार के लिए",
    timingsTitle: "बैच समय (संकेतात्मक)",
    timingsNote:
      "ये शाम के समय सोच-विचार में मदद के लिए हैं। बच्चे का बैच तय करने से पहले कृपया व्हाट्सऐप पर वर्तमान समय-सारणी और उपलब्धता पुष्टि करें।",
    slots: [
      { name: "बैच A", time: "शाम 4:30 – 5:30 · सोम–गुरु" },
      { name: "बैच B", time: "शाम 5:45 – 6:45 · सोम–गुरु" },
      { name: "बैच C", time: "शाम 7:00 – 8:00 · सोम–गुरु" },
      { name: "सप्ताहांत कक्षाएँ", time: "पूर्व निर्धारण से" },
    ],
    transTitle: "पहली बार हिंदी जुड़ रहे हैं?",
    transText:
      "हिंदी में नए बच्चों के लिए सहज और सुव्यवस्थित रास्ता — ज़रूरत हो तो वर्णमाला से शुरुआत, धीरे-धीरे अतिरिक्त अभ्यास, ताकि स्कूल डरावना न लगे और भाषा अपनी जैसी लगने लगे।",
    transCta: "ट्रांज़िशन सहारा पूछें",
  },
  faqs: {
    eyebrow: "सामान्य प्रश्न",
    title: "आम सवाल, सीधे जवाब",
    sub: "आपका प्रश्न यहाँ नहीं है? व्हाट्सऐप पर संदेश भेजिए — मैं व्यक्तिगत रूप से उत्तर देती हूँ।",
    items: [
      {
        q: "ये कक्षाएँ किनके लिए हैं?",
        a: "प्राथमिक और हाई स्कूल के विद्यार्थियों के लिए। कक्षाएँ ऑनलाइन होती हैं, इसलिए बच्चा कहीं से भी जुड़ सकता है; मैं हैदराबाद में हूँ।",
      },
      {
        q: "मेरे बच्चे ने कभी हिंदी नहीं पढ़ी। क्या वे जुड़ सकते हैं?",
        a: "हाँ। हिंदी में नए विद्यार्थियों को सिखाना मेरे काम का बड़ा हिस्सा है — ज़रूरत हो तो वर्णमाला से शुरुआत करते हैं और वही गति रखते हैं जिससे बच्चा सहज रहे।",
      },
      {
        q: "कक्षाएँ कैसे संचालित होती हैं?",
        a: "लाइव ऑनलाइन सत्रों के रूप में। बच्चे के पास इंटरनेट वाला फ़ोन, टैबलेट या कंप्यूटर होना चाहिए। बैच की जानकारी और प्लेटफ़ॉर्म पूछताछ पर साझा किया जाता है।",
      },
      {
        q: "कक्षाओं का समय क्या है?",
        a: "सप्ताह के दिनों में शाम के बैच, और सप्ताहांत में पूर्व निर्धारण से कक्षाएँ। ऑनलाइन कक्षाएँ पेज पर संकेतात्मक समय देखें, फिर व्हाट्सऐप पर उपलब्धता पुष्टि करें।",
      },
      {
        q: "शुल्क कितना है?",
        a: "शुल्क आपके बच्चे की कक्षा और ज़रूरत पर निर्भर करता है, इसलिए छोटी बातचीत के बाद व्यक्तिगत रूप से बताया जाता है। व्हाट्सऐप पर संदेश भेजिए, मैं सब स्पष्ट रूप से समझाऊँगी।",
      },
      {
        q: "क्या मेरी जानकारी गोपनीय रहेगी?",
        a: "हाँ। फ़ॉर्म की जानकारी केवल आपकी पूछताछ के उत्तर के लिए है — कभी साझा या बेची नहीं जाती। संपर्क पेज पर गोपनीयता नोट सरल शब्दों में समझाता है।",
      },
      {
        q: "हम शुरुआत कैसे करें?",
        a: "छोटा पूछताछ फ़ॉर्म भरिए — वह आपके लिए एक व्हाट्सऐप संदेश तैयार करेगा, जिसे देखकर भेजें। फिर बातचीत के लिए उपयुक्त समय तय करेंगे।",
      },
    ],
    stillTitle: "अभी भी कोई प्रश्न है?",
    stillText: "व्हाट्सऐप पर संदेश भेजिए — बच्चे की कक्षा और ज़रूरत बताइए, मैं व्यक्तिगत रूप से उत्तर दूँगी।",
    stillCta: "व्हाट्सऐप पर संदेश",
  },
  contact: {
    eyebrow: "संपर्क",
    title: "आइए, अपने बच्चे की हिंदी के बारे में बात करें",
    sub: "नीचे छोटा फ़ॉर्म भरें। हम आपके लिए एक व्हाट्सऐप संदेश तैयार करते हैं — आप उसे अपने ही व्हाट्सऐप से भेजते हैं।",
    formTitle: "पूछताछ फ़ॉर्म",
    labels: {
      name: "अभिभावक का नाम",
      namePh: "जैसे: लक्ष्मी राव",
      phone: "व्हाट्सऐप नंबर",
      phoneHint: "10 अंकों का मोबाइल नंबर",
      cls: "विद्यार्थी की कक्षा",
      need: "बच्चे को किसमें मदद चाहिए?",
      needPh: "एक चुनें",
    },
    classOptions: [
      "कक्षा 1", "कक्षा 2", "कक्षा 3", "कक्षा 4", "कक्षा 5",
      "कक्षा 6", "कक्षा 7", "कक्षा 8", "कक्षा 9", "कक्षा 10",
      "हिंदी बिल्कुल नई (अभी शुरू नहीं)",
    ],
    needOptions: [
      "स्कूल व परीक्षा सहायता",
      "व्याकरण व पठन",
      "हिंदी में नया (ट्रांज़िशन)",
      "गृहकार्य सहायता",
      "अन्य",
    ],
    submit: "मेरा व्हाट्सऐप संदेश तैयार करें",
    submitting: "तैयार हो रहा है…",
    errors: {
      name: "कृपया अभिभावक का नाम भरें।",
      phone: "कृपया 10 अंकों का सही व्हाट्सऐप नंबर भरें।",
      cls: "कृपया बच्चे की कक्षा चुनें।",
      need: "कृपया बताएं कि किसमें मदद चाहिए।",
    },
    review: {
      title: "आपका संदेश तैयार है — एक बार देख लें",
      explain:
        "“व्हाट्सऐप खोलें” दबाने पर व्हाट्सऐप खुलेगा और यह संदेश के वी नागलक्ष्मी (+91 99083 10130) के लिए तैयार मिलेगा। आप वहाँ संदेश बदल भी सकते हैं — भेजना वहाँ के Send बटन से ही होगा।",
      open: "व्हाट्सऐप खोलें और देखें",
      edit: "जानकारी बदलें",
      done: "भेज दिया? धन्यवाद!",
      doneText:
        "अगर व्हाट्सऐप नहीं खुला, तो नीचे दिए नंबर पर सीधे संपर्क करें। मैं सामान्यतः व्हाट्सऐप पर ही उत्तर देती हूँ।",
    },
    privacy: {
      title: "गोपनीयता, सरल शब्दों में",
      items: [
        "क्या लेते हैं: सिर्फ़ वही जो फ़ॉर्म पूछता है — अभिभावक का नाम, व्हाट्सऐप नंबर, बच्चे की कक्षा और ज़रूरत।",
        "किस काम में: आपकी पूछताछ का उत्तर देने और कक्षाएँ तय करने में। और किसी में नहीं।",
        "कभी साझा या बेची नहीं जाती। कोई विज्ञापन संदेश नहीं।",
        "जानकारी मिटानी है? व्हाट्सऐप पर कहिए — हो जाएगा।",
      ],
    },
    aside: {
      howTitle: "आगे क्या होगा",
      howItems: [
        "आप चार छोटे फ़ील्ड भरते हैं — बस इतना ही।",
        "हम व्हाट्सऐप संदेश तैयार करके पहले आपको दिखाते हैं।",
        "आप अपने ही व्हाट्सऐप से, तैयार होकर भेजते हैं।",
      ],
      directTitle: "खुद लिखना चाहेंगे?",
      directText: "के वी नागलक्ष्मी को सीधे व्हाट्सऐप पर संदेश भेजें।",
      location: "हैदराबाद · ऑनलाइन कक्षाएँ",
    },
    msg: {
      greet: "नमस्ते 🙏",
      intro: "मैं अपने बच्चे के लिए ऑनलाइन हिंदी कक्षाओं की जानकारी चाहती हूँ:",
      parent: "अभिभावक",
      cls: "विद्यार्थी की कक्षा",
      need: "ज़रूरत",
      close: "कृपया उपयुक्त समय और विवरण बताएं।",
      footer: "(वेबसाइट से भेजा गया)",
    },
  },
  footer: {
    tagline: "हिंदी, आत्मीयता से — ऑनलाइन, प्राथमिक एवं हाई स्कूल के विद्यार्थियों के लिए।",
    linksTitle: "पेज",
    contactTitle: "संपर्क",
    whatsapp: "व्हाट्सऐप",
    location: "हैदराबाद · ऑनलाइन कक्षाएँ",
    privacyLine: "पूछताछ की जानकारी केवल उत्तर देने के काम आती है — कभी साझा या बेची नहीं जाती।",
    rights: "सर्वाधिकार सुरक्षित।",
  },
};

export const copy = { en, hi };
